import type { BibleAsset } from './bibleConfig'

export interface BibleProduct {
  id: string
  asset: BibleAsset
  coverLines: string[]
  coverNote: string
  tag: string
  title: string
  description: string
}

export const bibleProducts: BibleProduct[] = [
  {
    id: 'bible',
    asset: 'bible',
    coverLines: ['VISUAL', 'DISRUPTION', 'BIBLE 2.0'],
    coverNote: 'EL MANUAL PRINCIPAL',
    tag: '01 / GUÍA PRINCIPAL · 70 PÁGINAS',
    title: 'Visual Disruption Bible 2.0',
    description:
      'Explora estética, movimientos de cámara y narrativa visual. Incluye una estructura de video por bloques y un plan de práctica de 30 días.'
  },
  {
    id: 'console',
    asset: 'console',
    coverLines: ['THE', 'COMMAND', 'CONSOLE'],
    coverNote: 'IMAGEN · COMPOSICIÓN · ESTILO',
    tag: '02 / PROMPTS DE IMAGEN · 60 PÁGINAS',
    title: 'The Command Console',
    description:
      'Ejemplos organizados por categorías, variables para personalizarlos y explicaciones de uso. Trabaja producto, marca personal y diferentes estilos visuales.'
  },
  {
    id: 'action',
    asset: 'action',
    coverLines: ['ACTION', 'SEQUENCE', 'SCRIPTS'],
    coverNote: 'ESCENAS · ACCIÓN · SECUENCIAS',
    tag: '03 / NARRATIVA DE VIDEO · 60 PÁGINAS',
    title: 'Action Sequence Scripts',
    description:
      'Ideas de escenas y ejemplos de secuencias con tiempos y notas de producción para planificar el desarrollo de una pieza.'
  },
  {
    id: 'hooks',
    asset: 'hooks',
    coverLines: ['THE', 'HOOK', 'LIBRARY'],
    coverNote: 'GANCHOS VISUALES · IDEAS',
    tag: '04 / APERTURAS VISUALES · 60 PÁGINAS',
    title: 'The Hook Library',
    description:
      'Explora ganchos de escala, física imposible, lujo y absurdo, y aprende a relacionar la apertura con el mensaje de tu anuncio.'
  },
  {
    id: 'rights',
    asset: 'rights',
    coverLines: ['COMMERCIAL', '& AGENCY', 'RIGHTS'],
    coverNote: 'APLICACIÓN A SERVICIOS',
    tag: '05 / ORIENTACIÓN COMERCIAL · 40 PÁGINAS',
    title: 'Commercial & Agency Rights',
    description:
      'Ideas de servicios, prospección, propuestas y entrega de trabajos. Incluye la autorización del material para usar sus prompts en servicios a clientes.'
  },
  {
    id: 'skool',
    asset: 'skool',
    coverLines: ['START', 'LAUNCHING', 'CREATIVES'],
    coverNote: 'ACCESO A LA COMUNIDAD',
    tag: '06 / GUÍA DE ACCESO · 16 PÁGINAS',
    title: 'Comunidad en Skool',
    description:
      'Accede al espacio de la comunidad para compartir tus creaciones e intercambiar ideas. Esta oferta no incluye un curso en video ni clases programadas.'
  }
]
